(function () {
    var authTokenRefreshService = (
    function authTokenRefreshService($window, $http) {
        this.$window = $window;
        this.$http = $http;
        return {
            refreshToken: refreshToken
        }
        function refreshToken(refreshTokenBaseUrl,serviceName) {
            var refreshTokenUrl = refreshTokenBaseUrl + '?serviceName=' + serviceName;

            return $http.get(refreshTokenUrl).then(refreshTokenComplete);

            function refreshTokenComplete(response) {
                return response;
            }
        }
    }
);

    var messageInterceptorsConfig = function ($provide, provider) {
        // push function to the interceptors which will intercept all the http responses
        provider.interceptors.push(['$q', '$injector', '$localForage', function ($q, $injector, $localForage) {
            return {
                responseError: function (errorResponse) {
                    var deferred = $q.defer();
                    var apiInfoObject = $localForage._localforage._apiInfo;
                    var serviceName = getServiceNameFromApiInfo(apiInfoObject, errorResponse);
                    var config = $injector.get('ssatbAuthTokenRefreshConfig');
                    if (serviceName != null && config.refreshTokenUrl != null && !angular.isUndefined(errorResponse.config) && errorResponse.config != null
                                && (angular.isUndefined(errorResponse.config.retry) || errorResponse.config.retry == false)
                                    && errorResponse.status === 401) {
                        $injector.get('authTokenRefreshService').refreshToken(config.refreshTokenUrl, serviceName).then(function (response) {
                            var apiInfo = apiInfoObject[errorResponse.serviceName];
                            apiInfo.Headers = response.data;
                            _retrySsatbHttpRequest(errorResponse.config, deferred, $injector);
                        }, function () {
                            if (!angular.isUndefined(config.errorHandler) && config.errorHandler != null)
                                config.errorHandler('An unexpected error occurred.  For assistance, please email info@enrollment.org.');
                            deferred.reject(errorResponse);
                        });
                    } else {
                        if (!angular.isUndefined(config.errorHandler) && config.errorHandler != null)
                            config.errorHandler('An unexpected error occurred.  For assistance, please email info@enrollment.org.');
                        deferred.reject(errorResponse);
                    }
                    return deferred.promise;

                    function getServiceNameFromApiInfo(apiInfoObject, errorResponse)
                    {
                        if (errorResponse.serviceName == null)
                            return null;
                        var apiInfo = apiInfoObject[errorResponse.serviceName];
                        if (apiInfo == null)
                            return null;
                        return apiInfo.ServiceName;
                    }
                }
            };
        }
        ])
    };
    var _retrySsatbHttpRequest = function (config, deferred, $injector) {
        $ssatbHttp = $injector.get('ssatbHttp');
        config.retry = true;
        $ssatbHttp(config).then(function (response) {
            deferred.resolve(response);
        }, function (response) {
            alertDialog('An unexpected error occurred.  For assistance, please email info@enrollment.org.');
            deferred.reject(response);
        });
    }
    angular.module('ssatb.authtokenrefresh', ['SSATB.LocalForage'])
        .provider('ssatbAuthTokenRefreshConfig', ['ssatbHttpProvider', function (ssatbHttpProvider) {
            var _config = {};
            this.config = function (config)
            {
                if (!angular.isObject(config))
                    throw new Error('The config parameter should be an object');
                _config = config;
            }
            this.$get = function () {
                return _config;
            }
            }])
        .config(['$provide', 'ssatbHttpProvider', messageInterceptorsConfig])
      .service('authTokenRefreshService', ['$window', '$http', authTokenRefreshService]);
})();
